export const SET_LOADING_POINTS = 'SET_LOADING_POINTS';
export const SET_POINTS = 'SET_POINTS';
export const SET_OPEN_POINT = 'SET_OPEN_POINT';
